<div class="wrapper mb-2">
    <div class="row">
        <div class="col-md-5 col-sm-12 text-left">
            <img src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Nova Recarga</span>
        </div>
        <div class="col-md-7 col-sm-12 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento col d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">FAVORECIDOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">PAGAMENTO</span>
                </div>
            </div>
        </div>

        <div class="component-box container-fluid">
            <div class="container-fluid mb-2">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 text-left mt-5 mb-1">
                        <div class="row button-container mb-3">
                            <div class="col-5 text-left component-title">Selecione os Favorecidos Ativos</div>
                            <div class="col-7 text-right">
                                <!--<button type="submit" class="custom-button-white" (click)="savePedido()">SALVAR</button>-->
                                <button type="submit" class="custom-button-back" (click)="previous()">Voltar</button>
                                <button type="submit" class="custom-button-full" (click)="next()">Continuar</button>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 component-subtitle">
                                <p class="component-subtitle color text-left"> {{count}} de {{totalItems}} favorecidos selecionados
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
                <div class="row">
            <div class="container-fluid">
                    <!--
                        Funcionalidade desativada em 03/09 -> https://app.asana.com/0/994556555396601/1192231162085265
                        Aguardando refatoração
                        <div class="text-right">
                            <div class="col-lg-12 col-md-12 col-sm-12 my-2">
                                <button type="button" class="list-header-button" (click)="newColaborador()">
                                    <img class="list-header-icon" src="./assets/icons/user-purple.png" />
                                    NOVO FAVORECIDO
                                </button>
                                <button type="button" class="list-header-button" (click)="showModal(modalColaboradorEsporadico)">
                                    <img class="list-header-icon" src="./assets/icons/user-purple.png" />
                                    FAVORECIDO ESPORÁDICO
                                </button>
                            </div>
                        </div>
                    -->
                    <!-- <div class="col-12">
                        <div class="custom-input-container mr-4 my-1">
                                <mat-checkbox class="" color="primary" [(ngModel)]="filtroWithoutGroup"  (change)="applyFilter()">Não listar quem possui este produto em um grupo Flex</mat-checkbox>
                        </div>
                    </div> -->
                    <div class="col-lg-2 col-md-2 col-sm-12">
                        <div class="list-select-all mr-4 my-1" [ngClass]="{'active': count>0}">
                            <span *ngIf="!selectAllItem" class="color" style="align-self: center; cursor: pointer;" (click)="selectAll()">Selecionar todos</span>
                            <span *ngIf="selectAllItem" class="color" style="align-self: center; cursor: pointer;" (click)="selectAll()">Desmarcar todos</span>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-12" style="max-inline-size: max-content;">
                        <button type="button" class="list-header-filter-button" style="margin-right: 5px;" (click)="showFilter(filtro)"><img
                            class="list-header-icon-filter" src="./assets/icons/filter-tool.png" />
                            Aplicar filtro
                        </button>
                        <button type="button" class="list-header-remove-filter-button" (click)="removerFilter()"><img
                            class="list-header-icon-filter" src="./assets/icons/garbage-grey.png" />
                            Remover filtro
                        </button>


                    </div>
                    <!-- <div class="col-lg-3 col-md-3 col-sm-12"><input class="list-header-search-input w-100" type="search" placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisa" /></div> -->
                    <div class="col-lg-5 col-md-5 col-sm-12">
                        <div class="row h-100">
                            <div class="list-show-item ml-auto">Mostrar:
                                <select (change)="showItemChanged($event.target.value)">
                                    <option [ngValue]="10" value="10">10</option>
                                    <option [ngValue]="25" value="25">25</option>
                                    <option [ngValue]="50" value="50">50</option>
                                    <option [ngValue]=100 value="100" selected>100</option>
                                </select>
                            </div>
                            <div class="list-pagination ml-auto">
                                <pagination-controls (pageChange)="loadPage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <!-- Listagem -->
            <div *ngIf="totalItems>0" class="table-responsive">
                <table class="list-table table table-striped">
                    <thead class="list-table-head">
                        <th></th>
                        <th class="" colspan="2" (click)="sortOrder= !sortOrder; orderBy('name', sortOrder)">
                            Nome
                        </th>
                        <th class="" (click)="sortOrder= !sortOrder; orderBy('document', sortOrder)">
                            CPF
                        </th>
                        <th class="" (click)="sortOrder= !sortOrder; orderBy('register', sortOrder)">
                            Matrícula
                        </th>
                        <th class="" (click)="sortOrder= !sortOrder; orderBy('costCenter', sortOrder)">
                            Centro de Custo
                        </th>
                        <th class="" (click)="sortOrder= !sortOrder; orderBy('unit', sortOrder)">
                            Unidade
                        </th>
                        <th class="" (click)="sortOrder= !sortOrder; orderBy('departament', sortOrder)">
                            Departamento
                        </th>
                        <th class="text-center" (click)="sortOrder= !sortOrder; orderBy('statusApp', sortOrder)">
                            Favorecido apto?
                        </th>
                    </thead>
                    <tbody class="list-table-row">
                        <tr *ngFor="let listColaborador of colaboradores | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems }"  class="list-table-cell" class="clickable" (click)="selectElement(listColaborador)">
                            <td>
                                <span>
                                    <input [attr.id]="listColaborador.collaboratorID" type="checkbox" class="radio-checkbox" [(ngModel)]="listColaborador.selected" (change)="selectElement(listColaborador)"/>
                                    <label [attr.for]="listColaborador.collaboratorID" class="radio-label"></label>
                                </span>
                            </td>
                            <td colspan="2">{{listColaborador.name}} </td>
                            <td>
                                <span *ngIf="listColaborador.document || listColaborador.document != null">{{ listColaborador.document | cpf }}</span>
                                <span *ngIf="!listColaborador.document || listColaborador.document == null"></span>
                            </td>
                            <td>{{listColaborador.registry}}</td>
                            <td>{{listColaborador.costCenter}}</td>
                            <td>{{listColaborador.unit}}</td>
                            <td>{{listColaborador.departament}}</td>
                            <td class="text-center">
                                <span *ngIf="(!listColaborador.hasCard && listColaborador.hasApp)" data-bs-toggle="tooltip" title="Já possui aplicativo">
                                    <img class="img-status" src="./assets/icons/status-green.png" />
                                </span>
                                <span *ngIf="(listColaborador.hasCard && !listColaborador.hasApp)" data-bs-toggle="tooltip" title="Já possui cartão">
                                    <img class="img-status" src="./assets/icons/status-green.png" />
                                </span>
                                <span *ngIf="(listColaborador.hasCard && listColaborador.hasApp)" data-bs-toggle="tooltip" title="Já possui aplicativo e cartão">
                                    <img class="img-status" src="./assets/icons/status-green.png" />
                                </span>
                                <span *ngIf="!listColaborador.hasApp && !listColaborador.hasCard">
                                    <img class="img-status" src="./assets/icons/status-yellow.png" data-bs-toggle="tooltip" title="Não possui aplicativo ou cartão"/>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div *ngIf="totalItems <= 0" class="text-center">
                <span>Nenhum favorecido carregado.</span>
            </div>
            
            <div *ngIf="colaboradorSelect === false">
                <span class="text-danger">Selecione ao menos um favorecido.</span>
            </div>
            <hr />

            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 text-right">
                        <div class="list-pagination ml-auto">
                            <pagination-controls (pageChange)="loadPage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 form-subtitle">
                        <p class="component-subtitle color text-right">{{count}} de {{totalItems}} favorecidos selecionados
                        </p>
                    </div>
                </div>
                <div class="container-fluid mt-3 mb-3">
                    <div class="row">
                        <div class="col text-right">
                            <!--<button type="submit" class="custom-button-white" (click)="savePedido()">SALVAR</button>-->
                            <button type="submit" class="custom-button-back" (click)="previous()">Voltar</button>
                            <button type="submit" class="custom-button-full" (click)="next()">Continuar</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Nome</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" [(ngModel)]="filtroNome" id="name">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>CPF</mat-label>
                <input [formControl]="cpfCtrl" matInput type="text" [(ngModel)]="filtroCPF" id="cpf">
                <button mat-button *ngIf="filtroCPF" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCPF=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>Matrícula</mat-label>
                <input [formControl]="registerCtrl" matInput type="text" [(ngModel)]="filtroMatricula" id="register">
                <button mat-button *ngIf="filtroMatricula" matSuffix mat-icon-button aria-label="Clear" (click)="filtroMatricula=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Centro de Custo</mat-label>
                    <mat-select [formControl]="costCenterCtrl" multiple>
                        <mat-option *ngFor="let item of filtroCentroCustoDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Unidade</mat-label>
                    <mat-select [formControl]="unitCtrl" multiple>
                        <mat-option *ngFor="let item of filtroUnidadeDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-input-container">
                <mat-form-field>
                    <mat-label>Departamento</mat-label>
                    <mat-select [formControl]="departmentCtrl" multiple>
                        <mat-option *ngFor="let item of filtroDepartamentoDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
    <!-- <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="nome">Nome:</label>
                <input id="nome" #nome class="clean-filter-input" type="text" value="{{ filtroNome }}" autocomplete="off"/>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="cpf">CPF:</label>
                <input id="cpf" #cpf class="clean-filter-input" type="text" value="{{ filtroCPF }}" autocomplete="off"/>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="matricula">Matricula:</label>
                <input id="matricula" #matricula class="clean-filter-input" type="text" value="{{ filtroMatricula }}"autocomplete="off" />
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label">Centro de Custo:</label>
                <ng-multiselect-dropdown [data]="filtroCentroCustoDropDownList" [(ngModel)]="filtroCentroCustoSelectedItems" [settings]="dropDownSettings" [placeholder]="
                        'Selecionar centros de custo'
                    " (onSelect)="onItemSelectFiltroCentroCusto($event)" (onSelectAll)="onSelectAllFiltroCentroCusto($event)" (onDeSelect)="onItemDeSelectFiltroCentroCusto($event)"></ng-multiselect-dropdown>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="unidade">Unidade:</label>
                <ng-multiselect-dropdown [data]="filtroUnidadeDropDownList" [(ngModel)]="filtroUnidadeSelectedItems" [settings]="dropDownSettings" [placeholder]="
                        'Selecionar unidades'
                    " (onSelect)="onItemSelectFiltroUnidade($event)" (onSelectAll)="onSelectAllFiltroUnidade($event)" (onDeSelect)="onItemDeSelectFiltroUnidade($event)"></ng-multiselect-dropdown>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-input-container">
                <label class="clean-filter-label" for="departamento">Departamento:</label>
                <ng-multiselect-dropdown [data]="filtroDepartamentoDropDownList" [(ngModel)]="filtroDepartamentoSelectedItems" [settings]="dropDownSettings" [placeholder]="
                        'Selecionar departamentos'
                    " (onSelect)="onItemSelectFiltroDepartamento($event)" (onSelectAll)="onSelectAllFiltroDepartamento($event)" (onDeSelect)="onItemDeSelectFiltroDepartamento($event)"></ng-multiselect-dropdown>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter(nome.value, cpf.value, matricula.value,
            filtroCentroCustoSelectedItems, filtroUnidadeSelectedItems,
            filtroDepartamentoSelectedItems);modal.dismiss('Close click')">
            APLICAR
        </button>
    </div> -->
</ng-template>


<!-- Modal favorecido Esporádico -->
<ng-template #modalColaboradorEsporadico let-modal>
    <div class="container-fluid mb-5 mt-5">
        <div class="row mx-5">
            <div class="col">
                <input class="list-header-search-input w-100" type="search" placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisaSporadic" />
            </div>
        </div>

        <hr />
        <div class="table-responsive">
            <table class="list-table table table-striped">
                <thead class="list-table-head">
                    <th></th>
                    <th class="" colspan="2" (click)="sortOrder= !sortOrder; orderBy('nome',
            sortOrder)">Nome</th>
                    <th class="" (click)="sortOrder= !sortOrder; orderBy('documento',
            sortOrder)">CPF</th>
                    <th class="" (click)="sortOrder= !sortOrder; orderBy('matricula',
            sortOrder)">Matricula</th>
                    <th class="" (click)="sortOrder= !sortOrder;
            orderBy('nomeCentroCusto', sortOrder)">Centro de Custo
                    </th>
                    <th class="" (click)="sortOrder= !sortOrder; orderBy('nomeUnidade',
            sortOrder)">Unidade</th>
                    <th class="" (click)="sortOrder= !sortOrder;
            orderBy('nomeDepartamento', sortOrder)">
                        Departamento
                    </th>
                    <th class="text-center" (click)="sortOrder= !sortOrder;
            orderBy('statusApp', sortOrder)">
                        Aplicativo
                    </th>
                </thead>
                <tbody class="list-table-row">
                    <tr *ngFor="let listColaborador of colaboradoresList | paginate: {id:
                'paginationModal', itemsPerPage: 5, currentPage: currentPageModal } |
                modalFilterColaborador: filtroPesquisaSporadic"
              class="list-table-cell" class="clickable" (click)="listColaborador.esporadico= !listColaborador.esporadico;
              updateEsporadicos(); updateCount();">

                        <td>
                            <span>
                <input [attr.id]="listColaborador.colaboradorId" type="checkbox" class="radio-checkbox"
                  [(ngModel)]="listColaborador.esporadico" (click)="listColaborador.esporadico=
                  !listColaborador.esporadico; updateEsporadicos();
                  updateCount();" />
                <label [attr.for]="listColaborador.colaboradorId" class="radio-label"></label>
              </span>
                        </td>
                        <td colspan="2">{{listColaborador.nome}} {{listColaborador.sobrenome}}</td>
                        <td>{{listColaborador.documento}}</td>
                        <td>{{listColaborador.matricula}}</td>
                        <td>
                            <span *ngIf="listColaborador.nomeCentroCusto">{{listColaborador.nomeCentroCusto}}</span>
                        </td>
                        <td>
                            <span *ngIf="listColaborador.nomeUnidade">{{listColaborador.nomeUnidade}}</span>
                        </td>
                        <td>
                            <span *ngIf="listColaborador.nomeDepartamento">{{listColaborador.nomeDepartamento}}</span>
                        </td>
                        <td class="text-center">
                            <span *ngIf="listColaborador.hasApp || listColaborador.hasCard">
                                <img class="img-status" src="./assets/icons/status-green.png" />
                            </span>
                            <span *ngIf="!listColaborador.hasApp && !listColaborador.hasCard">
                                <img class="img-status" src="./assets/icons/status-yellow.png" />
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr />
        <div class="col text-center">
            <div class="list-pagination ml-auto">
                <pagination-controls id="paginationModal" (pageChange)="currentPageModal=
          $event" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
            </div>
        </div>
        <div class="col-12 text-right">
            <button class="custom-button-full" type="button" (click)="updateEsporadicos();modal.dismiss('Close click');">
        OK
      </button>
        </div>
    </div>
</ng-template>

<ng-template #noSelectColaborador let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Selecione ao menos 1 favorecido para processeguir.</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-footer text-center">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="modal.dismiss('Close click')">
            OK
        </button>
    </div>
</ng-template>

<ng-template #noColaborador let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Não existe favorecido associado a esse produto.</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-footer text-center">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="navigateToColaborador();modal.dismiss('Close click')" style="background-position: 95% 50%;">
            Clique aqui para cadastrar um favorecido a esse produto.
        </button>
    </div>
</ng-template>
